import { View, Text, Image, IconClickable } from 'src/components/common';
import { connect } from 'react-redux';
import './styles.scss';
import { IAppState } from 'src/store';
import { People } from 'src/dataFactory/depositionFactory';
import React from 'react';
import { getUserPositionDisplay } from 'src/utils';
const InvolvedPartiesToAdd: React.FC<Props> = ({ className, user, onRemoveParty }) => {
  return (
    <View className={className ? className : ''} isRow align="center">
      <View className={'cmp-deposition-detail'} isRow>
        <Image src={user.imageURL} className="cmp-deposition-detail__image" />
        <View className={'cmp-deposition-detail__image--with-text'}>
          <Text style={{ fontWeight: 'bold' }}>{user.name}</Text>
          <Text>
            {`${user.email} / `}
            <span style={{ textTransform: 'capitalize' }}>{getUserPositionDisplay(user.position)}</span>
          </Text>
          {user.companyOrLawFirm && <Text>{user.companyOrLawFirm}</Text>}
        </View>
      </View>
      {onRemoveParty && (
        <IconClickable
          key={`involed-remove-${user.id}`}
          name="ic_close"
          className={'cmp-deposition-file__item-icon cmp-deposition-file__item-icon-download'}
          onClick={() => {
            onRemoveParty(user.id);
          }}
        />
      )}
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    user: People;
    className?: string;
    onRemoveParty?: (is: string) => void;
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InvolvedPartiesToAdd);
